// extracted by mini-css-extract-plugin
module.exports = {"container":"_2h4ayIicg3ZqE2pRt357Xk","message":"d00IqbE5oJaTbr_mjvd2B","infoIcon":"_22WXrxcDim7JnBdKNbh019"};